import React, { useState, useRef, useEffect, useCallback } from "react";
import { SideSVG } from "../../common";
import { ReactComponent as Email } from "../../../assets/images/signUp/email.svg";
import { Link } from "react-router-dom";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrowright.svg";
import Logo from "../Logo";
import { useVerificationMutation } from "../../../store/auth/usersApiSlice";
import ReactGA from "react-ga4";

const Verification = ({ onPrev, onEmail, onNext, verificationCode }) => {
  const inputRefs = useRef([]);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isButtonValid, setIsButtonValid] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Wrong OTP Please Try Again");
  const [verify, { isLoading }] = useVerificationMutation();

  const handleSubmit = async (event) => {
    event.preventDefault();
    ReactGA.event({
      category: 'Create New Account',
      action: 'Submitted OTP for login',
      label:`user Doing verification using OTP; ${onEmail.replace(/@/g, '=')}`,
    });
    let otpNumber = Number(otp.join(""));

    // call verification API again and send verificationCode and otpNumber
    // - verificationCode is the encypted code
    // - otpNumber is the OTP entered by user 

    try {
      const res = await verify({
        email: onEmail,
        encrypted: verificationCode,
        code: otpNumber
      }).unwrap();


      if (res?.status) {
        if (res?.status === "OTP_VALIDATED") {
          // TODO: make toster here
          sessionStorage.setItem("temp_token", res.token);
          onNext();
        } else {
          if (res?.status === "OTP_EXPIRED") {
            setIsButtonValid(false)
          }
          setError(true);
          setErrorMessage(res?.message)
        }
      } else {
        setError(true);
        setErrorMessage("Something Went Wrong")
      }



    } catch (error) {
      setError(true);
      setErrorMessage(error)
    }

    // if (verificationCode !== otpNumber) {
    //   setError(true);
    //   return;
    // }
    // onNext();
  };

  const handleChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value;
    setOtp(newOtp);
    if (e.target.value !== "" && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const validate = useCallback(() => {
    let has6Digits = otp.every((item) => item !== "");
    setIsButtonValid(has6Digits);
  }, [otp]);

  useEffect(() => {
    validate();
  }, [validate]);

  const handlePaste = (e) => {
    e.preventDefault();

    const pastedText = e.clipboardData.getData('text');

    // Update the OTP values based on the pasted text
    const newOtp = pastedText
      .split('')
      .slice(0, otp.length)
      .map((char) => char);

    setOtp(newOtp);
  };

  return (
    <section className="relative px-4 py-20 lg:py-0 overflow-hidden">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <Logo classes="max-w-md lg:py-5 mx-auto absolute top-[-3.75rem] left-1/2 transform -translate-x-1/2 sm:left-10 sm:top-5 sm:z-10" />
          <div className="flex flex-wrap -mx-4 xl:items-center items-center">
            <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div className="max-w-md lg:py-20 mx-auto ">
                <h3 className="font-heading text-f24 sm:text-f36 text-primary font-bold mb-4 text-center">
                  Check your email
                </h3>
                <p className="text-lg text-secondary mb-10 text-center text-f14 sm:text-para3">
                  Please enter the verification code we sent to:
                  <p className="font-semibold">{onEmail}</p>
                </p>
                <div className="inline-flex items-center justify-center space-x-2 mb-6">
                  {otp.map((digit, index) => (
                    <React.Fragment key={index}>
                      {index > 0 && index % 3 === 0 && (
                        <div
                          className="w-5 h-12 bg-gray-300 self-center"
                          style={{ height: "5px" }}
                        ></div>
                      )}
                      <input
                        ref={(ref) => (inputRefs.current[index] = ref)}
                        type="text"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        onPaste={handlePaste}
                        className="w-12 h-12 text-2xl text-center border border-gray-400 rounded focus:outline-none focus:border-blue-500 bg-gray-100 placeholder-gray-400 placeholder-3xl"
                        placeholder="0"
                        style={{ height: "45px" }}
                      />
                    </React.Fragment>
                  ))}
                </div>
                {error && (
                  <p className="mb-2 text-red-500">
                    {errorMessage}
                  </p>
                )}
                <button
                  className="relative group w-full mb-6 py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center mr-2 gap-4"
                  type="submit"
                  onClick={handleSubmit}
                  disabled={!isButtonValid}
                >
                  <span className="relative">Next</span>
                  <ArrowRight />
                </button>
                <div className="inline-flex items-center justify-center text-f14 gap-1 mr-2 text-secondary">
                  <p>Didn't get the email? </p>
                  <Link
                    onClick={onPrev}
                    className="cursor-pointer text-primaryText font-semibold"
                  >
                    Resend or edit your email address
                  </Link>
                </div>
              </div>
            </div>

            <SideSVG SVG={Email} positions="bottom-0  left-[-25%]" />

          </div>
        </div>
      </div>
    </section>
  );
};

export default Verification;
